import { Link } from 'react-router-dom';
import { useResource } from '../../hooks';
import { ErrorNotice, StatusBadge } from '../../components/ui';
import { staffApi } from '../../staffApi';
import type { AddonInfo } from '../../staffApi';
import { StaffTableSkeleton } from './StaffApp';
import { eventNote } from './StaffOrganizationPage';
import { Table } from '../../components/primitives';


/** Every staff sign-in and change, newest first — the console's own audit,
 * separate from any organization's Activity page. */
export function StaffActivityPage({ addons }: { addons: AddonInfo[] }) {
  const audit = useResource(() => staffApi.audit(), []);

  return (
    <section className="staff-page">
      <div className="overview-header">
        <div>
          <h1 className="overview-header__title">Staff activity</h1>
        </div>
      </div>
      {audit.error ? <ErrorNotice error={audit.error} /> : null}
      {audit.loading && !audit.data ? (
        <div role="status" aria-label="Loading staff activity">
          <StaffTableSkeleton withHeader={false} />
        </div>
      ) : audit.data && audit.data.events.length === 0 ? (
        <p className="quiet-empty">No activity</p>
      ) : audit.data ? (
        <Table label="Staff activity" className="staff-table">
          <thead>
            <tr>
              <th scope="col">When</th>
              <th scope="col">What</th>
              <th scope="col">Organization</th>
              <th scope="col">Staff</th>
              <th scope="col">Note</th>
            </tr>
          </thead>
          <tbody>
            {audit.data.events.map((event) => {
              return (
                <tr key={event.id}>
                  <td>
                    <time dateTime={event.occurred_at}>{new Date(event.occurred_at).toLocaleString()}</time>
                  </td>
                  <td>
                    <StatusBadge kind="staffAction" value={event.action} />
                    {typeof event.details?.addon === 'string' ? (
                      <div className="staff-table__sub">
                        {addons.find((a) => a.key === event.details.addon)?.label ?? 'Unknown add-on'}
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {event.organization_id ? (
                      <Link to={`/staff/organizations/${event.organization_id}`}>{event.organization_name || 'Deleted organization'}</Link>
                    ) : (
                      <span className="muted">—</span>
                    )}
                  </td>
                  <td className="staff-table__wrap">{event.actor}</td>
                  <td className="staff-table__wrap">{eventNote(event) || <span className="muted">—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : null}
    </section>
  );
}
